export default __webpack_public_path__ + "static/media/viande.7dbb148b.png";